import {
    Organization,
    OrganizationServicesOffered,
} from "@common/types/organization";
import { OrganizationDtoSchema } from "@common/schemas/organization.schema";
import { OrganizationWorkspaceAssignment } from "../../types/organizationWorkspaceAssignment";

export class OrganizationWorkspaceAssignmentDto {
    static deserialize(
        dto: OrganizationWorkspaceAssignmentDto,
    ): OrganizationWorkspaceAssignment {
        return {
            ...dto,
            organization: dto.organization
                ? OrganizationDtoSchema.parse(dto.organization)
                : undefined,
        };
    }

    workspaceId: string;
    organizationId: string;
    organization?: Organization;
    createdAt: Date;
    updatedAt: Date;
    note: string | null;
    billingOwnership: boolean;
    servicesOffered: OrganizationServicesOffered[];

    constructor(assignment: OrganizationWorkspaceAssignment) {
        this.workspaceId = assignment.workspaceId;
        this.organizationId = assignment.organizationId;
        this.billingOwnership = assignment.billingOwnership;
        this.organization = assignment.organization;
        this.createdAt = assignment.createdAt;
        this.updatedAt = assignment.updatedAt;
        this.note = assignment.note;
        this.servicesOffered = assignment.servicesOffered;
    }
}
